import React from "react";
import credit from "../../assets/images/credit-card.png";
import paypal from "../../assets/images/paypal.png";
import paypal1 from "../../assets/images/PayPalCard.png";
import creditCard from "../../assets/images/credit-card (2).png";
import "./footer.css"
import { Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import logo from "../../assets/images/Serve Biznes logo.png";

const Footer = () => {
  const notify = () => {
    toast.success("You have successfully subscribed!", {
      position: "top-right",  // Use string value directly
      autoClose: 3000,
    });
  };

  return (
    <>
      {/* Remove the container if you want to extend the Footer to full width. */}
      <div className="container-fluid p-0 mt-5"   style={{ backgroundColor: "#3e4551" }}>
        {/* Footer */}
        <div className="container">
          <footer
            className="text-center text-lg-start text-white footer_main_org"
          
          >

            {/* Grid container */}
            <div className="container-fluid px-4 helpful_boxs">
              <div className="row py-3 py-md-5 pb-0 pb-md-5">
                <div className="col-md-3 mb-4 mb-md-0 d-flex gap-4 align-items-center justify-content-center">
                  <div className="quote_icon">
                    <i class="fa-regular fa-envelope"></i>
                  </div>
                  <div className="quote_des">
                    <h5 className="mb-0">Get a Quote Now</h5>
                    <p className="mb-0">send us a email</p>
                  </div>
                </div>
                <div className="col-md-3 mb-4 mb-md-0 d-flex gap-4 align-items-center justify-content-center">
                  <div className="quote_icon">
                    <i class="fa-solid fa-headset"></i>
                  </div>
                  <div className="quote_des">
                    <h5 className="mb-0">Call (123) 456-7890</h5>
                    <p className="mb-0">Mon-Fri: 9 am to 19 pm</p>
                  </div>
                </div>
                <div className="col-md-3 mb-4 mb-md-0 d-flex gap-4 align-items-center justify-content-center">
                  <div className="quote_icon">
                    <i class="fa-solid fa-truck"></i>
                  </div>
                  <div className="quote_des">
                    <h5 className="mb-0">Delivery</h5>
                    <p className="mb-0">Free and Safe</p>
                  </div>
                </div>
                <div className="col-md-3 mb-4 mb-md-0 d-flex gap-3 align-items-center justify-content-center ">
                  <div className="quote_icon">
                    <i class="fa-solid fa-thumbs-up"></i>
                  </div>
                  <div className="quote_des">
                    <h5 className="mb-0">Facebook</h5>
                    <p className="mb-0">Like Us</p>
                  </div>

                </div>
              </div>
            </div>
            <div className="container-fluid p-4 py-3 py-md-5 pb-0 footer-items">
              {/* Section: Links */}
              <section className="">
                {/*Grid row*/}
                <div className="row">
                  {/*Grid column*/}
                  <div className="col-lg-4 col-md-6 mb-4 mb-md-0 text-start">
                    <h5 className="text-uppercase">About US</h5>
                    <p className="pt-2 about_des">
                      Big Dreams Start Small Live Your Life Beautifully. Car
                      insurance helps to protect you against financial loss in the
                      event of an accident, theft or damage to your car. Auto
                      insur- ance covers the injuries and damages.
                    </p>
                  </div>
                  {/*Grid column*/}
                  {/*Grid column*/}
                  <div className="col-lg-2 col-md-6 mb-4 mb-md-0 text-start">
                    <h5 className="text-uppercase">Contact</h5>
                    <ul className="list-unstyled mb-0 footer_lists">
                      <li>
                        <i class="fa-solid fa-location-dot" className="me-2"></i>
                        <Link to="#!" className="text-white">
                          123 Motor St, Car City
                        </Link>
                      </li>
                      <li>
                        <i class="fa-solid fa-location-dot" className="me-2"></i>
                        <Link to="tel:(123) 456-7890" className="text-white">
                          (123) 456-7890
                        </Link>
                      </li>
                      <li>
                        <i class="fa-solid fa-location-dot" className="me-2"></i>
                        <Link
                          to="mailto: info@motoreasy.com"
                          className="text-white"
                        >
                          info@motoreasy.com
                        </Link>
                      </li>
                    </ul>
                  </div>
                  {/*Grid column*/}
                  {/*Grid column*/}
                  <div className="col-lg-2 col-md-6 mb-4 mb-md-0 text-start">
                    <h5 className="text-uppercase">About</h5>
                    <ul className="list-unstyled mb-0 footer_lists">
                      <li>
                        <Link to="/About-us">About Us</Link>
                      </li>
                      <li>
                        <Link to="contact-us">Contact Us</Link>
                      </li>
                      <li>
                        <Link to="/Blogs">Blog</Link>
                      </li>
                    </ul>
                  </div>
                  {/*Grid column*/}
                  {/*Grid column*/}
                  <div className="col-lg-2 col-md-6 mb-4 mb-md-0 text-start">
                    <h5 className="text-uppercase">Services</h5>
                    <ul className="list-unstyled mb-0 footer_lists">
                      <li>
                        <Link to="/Used-Car-Warrenty">Used Car Warranty</Link>
                      </li>
                      <li>
                        <Link to="/Vehicle-inspections">Vehicle Inspection</Link>
                      </li>
                      <li>
                        <Link to="Vehicle-Service">Vehicle Service</Link>
                      </li>
                      <li>
                        <Link to="/Road-side">Road Side</Link>
                      </li>
                      <li>
                        <Link to="/Battery-Replacement">Battery Replacement</Link>
                      </li>
                      <li>
                        <Link to="/Wind-screen-Repair">Windscreen Repair</Link>
                      </li>
                    </ul>
                  </div>
                  {/*Grid column*/}
                  {/*Grid column*/}
                  <div className="col-lg-2 col-md-6 mb-4 mb-md-0 text-start">
                    <h5 className="text-uppercase">Pages</h5>
                    <ul className="list-unstyled mb-0 footer_lists">
                      <li>
                        <Link to="/FAQ-page">FAQ</Link>
                      </li>
                      <li>
                        <Link to="/testominals">Testimonial</Link>
                      </li>
                      <li>
                        <Link to="/Pricing">Pricing</Link>
                      </li>
                    </ul>
                  </div>
                  {/*Grid column*/}
                </div>
                {/*Grid row*/}
              </section>
              {/* Section: Links */}
              <hr className="mb-4" />
              {/* Section: CTA */}
              <section className="">
                <div className="row d-flex align-items-center gap-3 gap-md-0">
                  <div className="col-md-6">
                    <div className="email-form">
                      <h4>Get our latest news and special sales</h4>
                      <form action="" className="d-flex w-100">
                        <input
                          type="email"
                          className=" w-75"
                          placeholder="enter your email"
                          required
                        />
                        <button
                          type="submit"
                          className="w-25 btn btn-info rounded-0 text-light fw-light fw-md-bold"
                          onClick={notify}
                        >
                          Subscribe
                        </button>

                        <ToastContainer />
                      </form>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="payment-options d-flex justify-content-center justify-content-md-end gap-4 mt-0 mt-md-4">
                      <img className="rounded" src={credit} width={50} alt="" />
                      <img className="rounded" src={paypal} width={50} alt="" />
                      <img className="rounded" src={paypal1} width={50} alt="" />
                      <img className="rounded" src={creditCard} width={50} alt="" />
                    </div>
                  </div>
                </div>
              </section>
              {/* Section: CTA */}
            </div>
            {/* Grid container */}
          </footer>
        </div>

        {/* Footer */}

      </div >
      {/* End of .container */}
    </>
  );
};

export default Footer;
